import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ScreenClassProvider } from "react-grid-system";

import 'shared-portal-component/dist/shared-portal-component.css'; // Ensure styles are imported before App
import App from "@/App";
import '@/styles/index.css';
import '@/styles/ResetCss.scss';

import { initializeGridConfig } from "@/config/gridConfig";
initializeGridConfig();

// Load the sixes data
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- root element guaranteed to exist in index.html
createRoot(document.getElementById("root")!).render(
  <StrictMode>
     <ScreenClassProvider>
    <App />
    </ScreenClassProvider>
  </StrictMode>,
);

